<template>
    <v-layout wrap v-if="pillList && pillList.length > 0" class="filter-pills-list">
        <filter-pill v-for="(filter, index) in pillList"
                     class="filter-pills-list__item"
                     :filter-index="index"
                     :handle-close="pillList.length > 1 ? handleClose : handleClear"
                     :key="index"
                     :pill-item="filter">
        </filter-pill>
        <v-flex class="filter-pills-list__clear-all pointer" @click="handleClear" data-qe-id="filter_clear_all_button">
            <span><v-icon color="black" size="18">close</v-icon></span>
            <span class="filter-pills-list__clear-all-label">{{memberDirectoryPageConstant.label.CLEAR_ALL}}</span>
        </v-flex>
    </v-layout>
</template>
<script>
    import FilterPill from "./FilterPill";
    import { memberDirectoryPageConstant, sortListAlphabeticallyAsc } from "../memberDirectoryPage.constants";

    export default {
        name: 'FilterPillsList',
        components: {
            FilterPill,
        },
        data() {
            return {
                memberDirectoryPageConstant,
            };
        },
        props: {
            selectedFilters: {
                type: Object,
                required: true,
            },
            handleClose: {
                type: Function,
                required: true,
            },
            handleClear: {
                type: Function,
                required: true,
            },
        },
        computed: {
            pillList() {
                const pills = [];
                if (this.selectedFilters) {
                    Object.keys(this.selectedFilters).forEach((key) => {
                        if (this.selectedFilters.hasOwnProperty(key) && key.length > 0 &&
                            key !== memberDirectoryPageConstant.constant.selectedOneClickChapter) {
                            pills.push(...sortListAlphabeticallyAsc(this.selectedFilters[key]));
                        }
                    });
                }
                return pills;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .filter-pills-list {
        padding: 15px 0;

        &__item {
            margin-right: 10px;
            margin-bottom: 15px;
        }

        &__clear-all {
            background-color: $white;
            flex: 0 1 auto !important;
            padding: 5px 10px;

            &-label {
                padding-left: 5px;
                color: $ypo-cta;
            }
        }
    }

</style>
